module.exports = __webpack_public_path__ + "img/background960w_original.46a14ca4.png";